angular.module('charts')
  .directive("customDateRange", ['$locale', 'translateFilter', function($locale, translateFilter) {
    return {
      restrict: "E",
      scope: {
        years: '=',
        allowCurrentDate: '=',
        showHotspot: '='
      },
      templateUrl: '/resources/charts/partials/custom-date-range.html',
      controller: ['$scope', '$element', 'timeframe', '$state', '$timeout', 'moment', 'configuration', 'dblAnalyticsProvider', function($scope, $element, $timeframe, $state, $timeout, $moment, $configuration, $analytics) {

        $scope.submitEnabled = false;

        $scope.dateOptions = {
          showWeeks: false,
          formatYear: 'yy',
          startingDay: 0
        };

        $scope.formatFrom = "'" + translateFilter('shared.labels.from') + "' " + $locale.DATETIME_FORMATS.mediumDate;
        $scope.formatTo = "'" + translateFilter('shared.labels.to') + "' " + $locale.DATETIME_FORMATS.mediumDate;

        var setDefaultDates = function() {
          var minMax, overrideFrom, overrideTo;

          if ($timeframe.isCustomRange()) {
            overrideFrom = $moment($timeframe.getFromDate(), 'YYYYMMDD');
            overrideTo = $moment($timeframe.getToDate(), 'YYYYMMDD');
            minMax = $timeframe.calculateCustomMinMax($scope.years.list, overrideFrom, overrideFrom, $scope.allowCurrentDate);

            // This checks to make sure the custom date range in the state is valid.  If not,
            // then pretend like there are no pre-selected custom dates.
            if (minMax.from.min.isAfter(overrideFrom) || minMax.from.max.isBefore(overrideFrom) ||
                minMax.to.min.isAfter(overrideTo) || minMax.to.max.isBefore(overrideTo) ||
                overrideTo.isBefore(overrideFrom)) {
              overrideFrom = null;
              overrideTo = null;
            }

          } else {
            minMax = $timeframe.calculateCustomMinMax($scope.years.list, null, null, $scope.allowCurrentDate);
          }

          $scope.fd = {
            date: (overrideFrom || minMax.from.defaultValue).toDate(),  //tidbit: datepicker input doesn't format well if passed a Moment
            minDate: minMax.from.min,
            maxDate: minMax.from.max,
            status: {
              opened: false
            }
          };

          $scope.td = {
            date: (overrideTo || minMax.to.defaultValue).toDate(), //tidbit: datepicker input doesn't format well if passed a Moment
            minDate: minMax.to.min,
            maxDate: minMax.to.max,
            status: {
              opened: false
            }
          };
        };

        var updateSubmitEnabled = function() {
          $scope.submitEnabled = true;
        };

        $scope.$watch('years.list', function(newValue) {
          setDefaultDates();
          $scope.$watch('fd.date', onFromDateChange);
          $scope.$watch('td.date', onToDateChange);
        });

        // NOTE (Russell, 2016-01-12): I would much rather have an "on change" event drive this, rather than a $watch,
        //      but I've seen references on the internets that datepicker doesn't play well with ng-change.
        var onFromDateChange = function(newValue) {
          var momentFrom = $moment(newValue);
          var minMax = $timeframe.calculateCustomMinMax($scope.years.list, momentFrom, momentFrom, $scope.allowCurrentDate);

          $scope.td.minDate = minMax.to.min;
          $scope.td.maxDate = minMax.to.max;

          if (minMax.to.min.isAfter($scope.td.date) || minMax.to.max.isBefore($scope.td.date)) {
            $scope.td.date = minMax.to.max.toDate();
          }

          updateSubmitEnabled();
        };

        // NOTE (Russell, 2016-01-13): I would much rather have an "on change" event drive this, rather than a $watch,
        //      but I've seen references on the internets that datepicker doesn't play well with ng-change.
        var onToDateChange = function(newValue) {
          updateSubmitEnabled();
        };

        $scope.open = function($event, item) {
          $event.preventDefault();
          $event.stopPropagation();
          $timeout(function () {
            $scope[item].status.opened = !$scope[item].status.opened;

          });

          var otherItem = ( item === 'fd') ? 'td' : 'fd';
          $scope[otherItem].status.opened = false;
        };

        $scope.selectCustomDateRange = function(fd,td) {
          $analytics.eventTrack('Custom Date Range Selected', {category: 'Resource Used', label: String($moment(fd).format('YYYYMMDD')) + '-' + String($moment(td).format('YYYYMMDD'))} );
          $scope.$emit('customDateRangeSet', {'fd': fd, 'td': td});
        };

      }]
    };
  }]);
